var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"images-list"},_vm._l((_vm.images),function(image,index){return _c('div',{key:image,staticClass:"image",style:({ backgroundImage: `url('${_vm.appConfig.BACKEND_URL}${image}')` }),on:{"click":function($event){return _vm.showSlider(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }